import { render, staticRenderFns } from "./AddSafetyActivity.vue?vue&type=template&id=68bdf2d5&scoped=true"
import script from "./AddSafetyActivity.vue?vue&type=script&lang=js"
export * from "./AddSafetyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdf2d5",
  null
  
)

export default component.exports